import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoSignatureKeys = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 47,
	viewBox: "0 0 68 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 9.57143C0 5.94213 2.88528 3 6.44444 3H51.5556C55.1147 3 58 5.94213 58 9.57143V19.4286C58 23.0579 55.1147 26 51.5556 26H6.44444C2.88528 26 0 23.0579 0 19.4286V9.57143Z",
			fill: "#EDF2F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.5625 45C40.5625 46.1046 41.4579 47 42.5625 47C43.6671 47 44.5625 46.1046 44.5625 45L40.5625 45ZM33.4422 45C33.4422 46.1046 34.3376 47 35.4422 47C36.5468 47 37.4422 46.1046 37.4422 45H33.4422ZM22.1875 40.5C22.1875 41.842 21.0653 43 19.5938 43V47C23.1963 47 26.1875 44.1285 26.1875 40.5H22.1875ZM19.5938 43C18.1222 43 17 41.842 17 40.5H13C13 44.1285 15.9912 47 19.5938 47V43ZM17 40.5C17 39.158 18.1222 38 19.5938 38V34C15.9912 34 13 36.8715 13 40.5H17ZM19.5938 38C21.0653 38 22.1875 39.158 22.1875 40.5H26.1875C26.1875 36.8715 23.1963 34 19.5938 34V38ZM40.5625 40.95V45L44.5625 45V40.95H40.5625ZM35.4422 42.5L42.1031 42.5V38.5L35.4422 38.5V42.5ZM33.4422 40.5V45H37.4422V40.5H33.4422ZM24.1875 42.5H35.4422V38.5H24.1875V42.5ZM44.5625 40.95C44.5625 39.5582 43.4223 38.5 42.1031 38.5V42.5C41.2913 42.5 40.5625 41.8447 40.5625 40.95H44.5625Z",
			fill: "#C8D0D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14.5,
			cy: 14.5,
			r: 4.5,
			fill: "#C8D0D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28.5,
			cy: 14.5,
			r: 4.5,
			fill: "#C8D0D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 43.5,
			cy: 14.5,
			r: 4.5,
			fill: "#C8D0D9"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 53,
			cy: 15,
			r: 13,
			fill: "#C8D0D9",
			stroke: "white",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.123 18.3756L56.2564 12.2422",
			stroke: "white",
			strokeWidth: 2.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.1225 12.2422L56.2559 18.3756",
			stroke: "white",
			strokeWidth: 2.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNoSignatureKeys;
